export default "/dist/fonts/Roboto-Regular.ttf";